// extracted by mini-css-extract-plugin
export default {"link":"PrivacyPolicyLink_link__diagj"};